import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper } from '../../_components'
import Table, { SelectColumnFilter } from '../../_components/Table'
import Axios from 'axios'

export default function AllUsers() {

    const smsColumns = useMemo(
    () => [
        {
            Header: "Name",
            accessor: "name",
            sortable: false,
            filterable: false,
            // Cell: NameField
        },
        {
            Header: "Block No",
            accessor: "block"
        },
        {
            Header: "FFSG No.",
            accessor: "ffs_code"
        },
        {
            Header: "Plot No.",
            accessor: "plotno"
        },
        {
            Header: "Date Registered",
            accessor: "date"
        },
        {
            Header: "Actions",
            accessor: "id"
        },
        ]
    )

    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    useEffect( () => {
        if( loading ) {
          // fetchAllSMS()
        }
    },[ loading ])

    const fetchAllSMS = async() => {
        try {
            const response = await Axios.get( `https://mis.nec.go.ug/api/auth/farmer` )
            if( response.data ) {
                const results = response.data.records.map( farmer => {
                    return {
                        name: `${farmer.first_name} ${farmer.last_name}`,
                        block: farmer.block_number,
                        ffs_code: farmer.ffs_code,
                        date: farmer.created_at,
                        id: farmer.id,
                        district: farmer.district,
                        plotno: farmer.plotno
                    }
                } )
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            
        }
    }
    
    return (
    <Wrapper>
     <div className="flex flex-col">
        <h2 className="text-lg">All Users</h2>
        <Table
            rightButton={false}
            rightBtnCallback={ () => {}}
            rightButtonLabel={null}
            label="All Users"
            columns={smsColumns}
            data={[]}
            hidePagination={false}
            exportToExcel={() => {}}
            exportToCSV={() => {}}
        />
     </div>
    </Wrapper>
  )
}
